import {gql} from '@apollo/client'

export const CART_ITEM_FRAGMENT = gql`
  fragment CartItemFragment on CartItem {
    id
    name
    title
    guaranteed
    isGuaranteed
    category
    subcategory
  }
`
